import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import useSWR from 'swr';
import { images } from '../Constants/ImageUrls';
import { widgetExperimentIds } from '../Constants/PdpContants';
import { widgetVersionObj } from '../Constants/ProductPage';
import { ExperiemntImageData } from '../Constants/SampleAplusWidget';
import { fireFbConversionApiEvent } from '../Libs/fbpixel';
import {
  checkProductLength,
  getScreenName,
  getSkuType,
  keysToRemove,
  removeDefaultParams,
  scrollToTargetAdjusted,
} from './helper';
import { fireEventForRepeatUser, fireGAEvent } from './useFirebase';
import { OvalunaPrepaidIds } from '../Constants/PaymentPage';
import { getWebUserType } from './getWebUserType';
import { fireEvent } from './fireEvent';
import { getNewAndRepeatUser, setWebUserIdReact } from './commonUtils';

export const getPriceParams = (productData) => {
  const pricingParam =
    (parseInt(productData?.strikeprice) || parseInt(productData?.strikePrice)) +
    ', ' +
    parseInt(productData?.price) +
    ', ' +
    (parseInt(productData?.booster_discount_price) || 0) +
    ', ' +
    'NA';

  const delivery =
    parseInt(productData?.deliveryCharge) ||
    parseInt(productData?.delivery) ||
    0;
  const conversionParam =
    parseInt(productData?.price) +
    ', ' +
    delivery +
    ', ' +
    (parseInt(productData?.price) + delivery);
  return { pricingParam, conversionParam };
};
export const useProductPageConstructor = (productData, platform) => {
  const router = useRouter();
  useEffect(() => {
    if (platform != 'ido') {
      router.beforePopState(({ url, as, options }) => {
        fireEvent({
          category: 'clicked_back',
          product_id: productData?.id,
          name: productData?.name,
          screen_name: getScreenName(),
        });
        return true;
      });
      const { pricingParam, conversionParam } = getPriceParams(productData);
      const nickname = productData?.nickname
        ? checkProductLength(productData?.nickname)
        : checkProductLength(productData?.name);
      setWebUserIdReact();
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      let browserType = 'default';
      if (ua.includes('FBAN') || ua.includes('FBAV')) {
        browserType = 'facebook';
      } else if (ua.includes('Instagram')) {
        browserType = 'instagram';
      }
      fireEvent({
        category: 'viewed_landing_page',
        id: productData?.id,
        screen_name: 'PDP',
        term_id: productData?.offers?.[0]?.term_id || 'NA',
        offer_id: productData?.offers?.[0]?.offer_id || 'NA',
        pricing_param: pricingParam,
        conversion_param: conversionParam,
        trust_tag: productData?.signal?.name || '',
        //pdp_variant: productData?.widgets?.length > 0 ? "aplus" : "old",
        pdp_variant:
          productData?.widgets[0]?.version == widgetVersionObj.aPlusPlus
            ? 'aplus_plus'
            : 'aplus',
        selling_price: productData?.price,
        sku_nickname: nickname,
        sku_type: getSkuType(productData?.type),
        parent: getNewAndRepeatUser(),
        support_variable: browserType,
      });
      fireGAEvent({
        category: 'view_item',
        currency: 'INR',
        value: productData?.price,
        items: [
          {
            item_id: productData?.id,
            item_name: nickname,
            price: productData?.price,
            quantity: 1,
            item_brand: 'Mylo Family',
          },
        ],
      });
      fireGAEvent({
        category: 'select_item',
        item_list_name: 'product_click',
        items: [
          {
            item_id: productData?.id,
            item_name: nickname,
            price: productData?.price,
            quantity: 1,
            item_brand: 'Mylo Family',
          },
        ],
      });
      fireEventForRepeatUser('product_detail_page');
    }
  }, [router.query.product]);
};

export const getTwentyPercentUser = () => {
  let shop_data_oneFifth = '';
  if (!Cookies.get('twentyPercent')) {
    shop_data_oneFifth = Math.random() < 0.2 ? 'A' : 'B';
    const userTypeObj = {
      userType: shop_data_oneFifth,
    };
    let inSevenDays = new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 7);
    Cookies.set('twentyPercent', JSON.stringify(userTypeObj), {
      expires: inSevenDays,
      path: '/',
    });
  } else {
    if (Cookies.get('twentyPercent').includes('{')) {
      shop_data_oneFifth = JSON.parse(Cookies.get('twentyPercent'))?.userType;
    } else {
      shop_data_oneFifth = Cookies.get('twentyPercent');
    }
  }
  return shop_data_oneFifth;
};

export const imagekitImageLoader = (width, item) => {
  return `${item}?tr=w-${width}`;
};

export const fireScrollEvent = (name, productData) => {
  const { pricingParam, conversionParam } = getPriceParams(productData);
  fireEvent({
    category: 'page_scroll',
    product_id: productData?.id || 'NA',
    type: name,
    product_name: productData?.name || 'NA',
    offer_id: productData?.offers?.[0]?.offer_id || 'NA',
    term_id: productData?.offers?.[0]?.term_id || 'NA',
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    screen_name: 'PDP',
  });
};

export const fireClickedVarientOption = (
  selectedAttribute,
  option,
  type,
  from,
  productData,
) => {
  const { pricingParam, conversionParam } = getPriceParams(option);
  fireEvent({
    category: 'clicked_option',
    product_id: option?.product_id || 'NA',
    product_name: option?.name,
    attribute: selectedAttribute,
    option: type,
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    screen_name: from != 'size_chart' ? getScreenName() : from,
    parent:
      from == 'size_chart'
        ? 'size_chart'
        : from == 'select_size'
          ? 'select_size'
          : '',
    pdp_variant:
      productData?.widgets[0]?.version == widgetVersionObj.aPlusPlus
        ? productData?.isfashionReady
          ? 'aplus_plus_fashion_ready'
          : 'aplus_plus'
        : productData?.isfashionReady
          ? 'aplus_fashion_ready'
          : 'aplus',
  });
};

export const useIsDesktop = () => useMedia('(min-width: 720px)', false);

export const useScrollToWidget = (type) => {
  const [forceOpenWidget, setForceOpenWidget] = useState([]);
  const { data: returnWidgetOpen, mutate: mutateReturnWidgetData } =
    useSWR('widgetScroll');

  useEffect(() => {
    if (returnWidgetOpen?.scrollTo) {
      type === 'a++' ? setForceOpenWidget(['returnPolicy']) : null;
      const widgetToScroll = document.querySelector(returnWidgetOpen?.scrollTo);
      if (widgetToScroll) {
        scrollToTargetAdjusted(widgetToScroll, 150);
      }
      mutateReturnWidgetData({
        scrollTo: false,
        count: ~~returnWidgetOpen?.count,
      });
    }
  }, [returnWidgetOpen]);

  return { forceOpenWidget };
};

export const useScrolltoWidgetSetter = () => {
  const { data, mutate } = useSWR('widgetScroll', async () => {}, {
    fallbackData: { scrollTo: false, count: 0 },
    revalidateOnMount: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  function scrollToWidget(elm) {
    mutate(
      {
        scrollTo: elm,
        count: ~~data?.count + 1,
      },
      false,
    );
  }

  return { scrollToWidget };
};
export const getBrandName = (Category) => {
  switch (Category) {
    case 'MYLOCARE':
      return 'CARE';
    case 'MYLOVEDA':
      return 'VEDA';
    case 'MYLOESSENTIALS':
      return 'ESSENTIALS';
    default:
      return 'STORE';
  }
};

export const getExperimentalPdpWidgetsData = (widgets, productId) => {
  if (getWebUserType() === 'A' && widgetExperimentIds.includes(productId)) {
    return [ExperiemntImageData, ...widgets];
  }
  return widgets;
};

export const getUpdatedName = (productName) => {
  if (productName) {
    return productName.startsWith('Mylo') ? productName : 'Mylo ' + productName;
  }
};
export const arr = ['star', 'floral', 'pet-love', 'rainbow', 'heart-doodle'];
export const filePaths = {
  'star': '/images/diaper1/Diaper_Final_02.gltf',
  'floral': '/images/diaper2/Diaper_Final_02.gltf',
  'pet-love': '/images/diaper3/Diaper_Final_02.gltf',
  'rainbow': '/images/diaper4/Diaper_Final_02.gltf',
  'heart-doodle': '/images/Diaper_Final_01.gltf',
};
export const showReviewTagsAB = () => {
  return false;
};
export const getCategoryUrlBasedOnId = (objectId, categoryData) => {
  const allCategoryUrl = getAllCategories(categoryData);
  const uniqueUrls = getUniqueUrls(allCategoryUrl);
  const countUrls = uniqueUrls.length;
  const startPoint = objectId % countUrls;
  const endPoint = startPoint + 20;
  for (let i = 0; i < 20 && i < countUrls; i++) {
    uniqueUrls.push(uniqueUrls[i]);
  }
  const filteredUrls = uniqueUrls.filter(
    (data, index) => index >= startPoint && index < endPoint,
  );
  const newUrls = [...filteredUrls, ...hardcodedUrls];
  const newUniqueUrls = getUniqueUrls(newUrls);

  if (!newUniqueUrls.length) return '';

  let footNoteCategoryUrls = '<h3>Popular Categories</h3><p>';
  for (let url of newUniqueUrls) {
    footNoteCategoryUrls += `<a href="${url.value}">${url.name}</a> | `;
  }
  footNoteCategoryUrls += '</p>';
  return footNoteCategoryUrls;
};

export const getAllCategories = (
  categoryData,
  categoryUrls = [],
  level = 0,
) => {
  categoryData?.map((category, index) => {
    const subCateg = category.subCategories;
    const webUrl = category?.key;
    let tabName = category?.tabName;
    if (level == 1 && index != 0) {
      const firstTab = categoryData[0]?.tabName;
      tabName = firstTab + ' - ' + tabName;
    }
    if (webUrl) categoryUrls.push({ value: webUrl, name: tabName });

    if (subCateg)
      categoryUrls = getAllCategories(subCateg, categoryUrls, level + 1);
  });
  return categoryUrls;
};

export const getUniqueUrls = (objectData) => {
  let mymap = new Map();
  return objectData.filter((obj) => {
    const value = obj.value;
    if (mymap.has(value)) return false;
    mymap.set(value, true);
    return true;
  });
};

export const getImageAccToUser = (plusMinusDropDown) => {
  const widgetImage = showPlusImage() ? plusMinusDropDown : images.BlackArrow;
  const widgetClass = showPlusImage() ? 'plusImage' : 'rotateImageAplus';
  const obj = {
    widgetImage: widgetImage,
    widgetClass: widgetClass,
  };
  return obj;
};

export const handleWidgetAccToUser = (plusMinusDropDown, setWidgetHandle) => {
  const data = getImageAccToUser(plusMinusDropDown);
  setWidgetHandle(data);
};
export const showPlusImage = () => {
  return true;
};

export const applyGesture = (stateHandler) => {
  // stateHandler("lowOpacity");
  //     setTimeout(()=>{
  //         stateHandler("")
  //     },250)
};
export const fireFbAddToCart = (productCopy, RandomEventId) => {
  const eventData = {
    currency: 'INR',
    value: productCopy?.price,
    content_ids: productCopy?.id,
    content_type: 'product',
  };
  fireFbConversionApiEvent('AddToCart', eventData, RandomEventId);
};

export const getWorkboxCache = async () => {
  let cacheData = {};
  const cacheList = await window.caches.keys();
  await Promise.all(
    cacheList.map(async (key) => {
      const cacheName = key.toString();
      const cache = await window.caches.open(key);
      const cacheKeys = await cache.keys();
      const cacheLength = cacheKeys.length;
      if (cacheName != '')
        cacheData = { ...cacheData, [cacheName]: cacheLength };
    }),
  );
  return cacheData;
};

export const showCodTrustElement = (pid) => {
  return !OvalunaPrepaidIds.includes(Number(pid));
};

const hardcodedUrls = [
  {
    name: 'Cloth Diaper',
    value: '/category/reusable-cloth-diapers-5433',
  },
  {
    name: 'Maternity dresses',
    value: '/category/maternity-dresses-5366',
  },
  {
    name: 'Stretch Marks Kit',
    value: '/category/stretch-marks-6169',
  },
  {
    name: 'Stroller',
    value: '/category/stroller-7054',
  },
];

export const splitIntoColumns = (imagesData, count) => {
  let result = [];
  let itemPerColumn = imagesData.length / count;
  let initialIndex = 0;
  for (let i = 0; i < count; i++) {
    result.push([]);
  }
  // for (let i = 0; i < count; i++) {
  //     for (let j = initialIndex; j < itemPerColumn; j++) {
  //         result[i].push(imagesData[j]);
  //     }
  //     itemPerColumn += itemPerColumn;
  //     initialIndex += itemPerColumn;
  // }

  for (let j = 0; j < imagesData.length; j++) {
    let arrayIndex = j % count;
    result[arrayIndex].push(imagesData[j]);
  }

  return result;
};

export const getOriginalIndex = (imagesData, id) => {
  let res;
  imagesData?.map((image, index) => {
    if (image.id === id) res = index;
  });
  return res;
};

export const cashkaroParamsStorageHandler = () => {
  if (!Cookies.get('cashkaroDetails')) {
    const queryParams = new URLSearchParams(window.location.search);
    const data = queryParams?.get('utm_source');
    if (data === 'cashkaro' || data === 'affiliate') {
      const clickId =
        queryParams?.get('utm_content') || queryParams?.get('utm_campaign');
      const subClickId = queryParams?.get('utm_term');
      const cashkaroDetails = {
        clickId,
        subClickId,
      };
      let expiration = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      Cookies.set('cashkaroDetails', JSON.stringify(cashkaroDetails), {
        expires: expiration,
        path: '/',
      });
    }
  }
};

export const pdpDotsExperiment = (userType) => {
  return userType === 'A';
};

export function decodeHtmlEntities(htmlString) {
  return htmlString?.replace(/&#(\d+);/g, function (match, dec) {
    return String.fromCharCode(dec);
  });
}

const lotionDiscussionData = [
  {
    questionName: 'Where all can I apply the Mylo Baby Lotion?',
    acceptedAnswerText:
      'You can apply the lotion everywhere on the body except the face and private parts of your baby.',
  },
  {
    questionName: 'Can I use this Baby Body Lotion every day?',
    acceptedAnswerText: 'Yes, you can use it every day.',
  },
  {
    questionName: 'Is this Baby Moisturizing Cream suitable for newborns?',
    acceptedAnswerText: 'Yes, you can use it for newborns as well.',
  },
  {
    questionName: 'Can I use this Baby Lotion for Dry Skin?',
    acceptedAnswerText:
      'Yes, it is especially helpful in soothing skin dryness and conditions like eczema and psoriasis.',
  },
  {
    questionName: 'Which is the best whitening lotion for babies? ',
    acceptedAnswerText:
      'It’s important to understand that a baby’s skin complexion is determined by genetics and cannot be changed by a lotion, oil or soap.  ',
  },
  {
    questionName: 'Is this baby lotion for winter? ',
    acceptedAnswerText: 'Yes, you can use this lotion for your baby in winter.',
  },
  {
    questionName: 'What is the Mylo Baby Lotion price?',
    acceptedAnswerText:
      'You can get 200ml of Mylo’s baby body lotion for Rs. 299.',
  },
];

const shampooDiscussionData = [
  {
    questionName: 'How often should I use an onion shampoo?',
    acceptedAnswerText:
      'You can use onion hair shampoo 2-3 times a week for optimal results.',
  },
  {
    questionName: 'What are the benefits of onion shampoo?',
    acceptedAnswerText:
      'Onion shampoo benefits include promoting hair growth, strengthening strands, and reducing hair fall.',
  },
  {
    questionName: 'What is the Mylo onion shampoo price?',
    acceptedAnswerText: 'The price of Mylo onion shampoo (200ml) is Rs 299.',
  },
  {
    questionName: 'How to use onion shampoo for hair?',
    acceptedAnswerText:
      'You can apply onion hair shampoo to wet hair, massage gently, and rinse thoroughly. For best results, follow it with an onion conditioner or serum.',
  },
  {
    questionName: 'Which is the best onion shampoo for hair growth?',
    acceptedAnswerText:
      'If you’re looking for the best onion shampoo, then you can consider Mylo’s onion shampoo. Enriched with onion seed oil, tetrapeptide, plant keratin, Methi and Amla, it helps control hair fall, prevents hair thinning, strengthens roots and nourishes hair.',
  },
  {
    questionName: 'How effective is onion shampoo for hair fall?',
    acceptedAnswerText:
      'Using onion shampoo for hair can result in a reduction in hair fall with regular use. However, individual results may vary.',
  },
  {
    questionName: 'Is red onion shampoo good for dandruff as well?',
    acceptedAnswerText:
      'Yes, it can help combat dandruff and promote a healthier scalp.',
  },
  {
    questionName:
      'Which ingredients should an onion shampoo for hair growth have?',
    acceptedAnswerText:
      'The best onion shampoo for hair growth should contain onion seed oil, tetrapeptide, plant keratin, Methi and Amla.',
  },
];
const onionSerumDiscussionData = [
  {
    questionName: 'How to use this onion hair serum?',
    acceptedAnswerText:
      'Apply the serum to clean damp hair. Take a small amount and spread it evenly through the lengths of your hair. Leave it on without washing off for best results.',
  },
  {
    questionName: 'How effective is onion serum for hair growth?',
    acceptedAnswerText:
      'Onion serum is believed to be effective for hair growth due to its sulfur content, which may help improve blood circulation and promote hair follicle health. Results may vary from person to person.',
  },
  {
    questionName: 'How often can I use anti hair fall serum?',
    acceptedAnswerText:
      'You can use this serum after every hair wash on clean damp hair or before dry combing your hair.',
  },
  {
    questionName: 'When to use an anti-frizz hair serum?',
    acceptedAnswerText:
      'You can use hair serum for dry, frizzy hair when you want to control and manage frizz in your hair. Apply it after washing and conditioning, focusing on the ends and avoiding the roots.',
  },
  {
    questionName: 'Which is the best hair serum for frizzy hair?',
    acceptedAnswerText:
      'The ideal serum for frizzy hair depends on individual preferences and hair types. Popular options include serums containing ingredients like argan oil, keratin, or avocado for smoothing and frizz control.',
  },
  {
    questionName: 'What is the Mylo hair serum price?',
    acceptedAnswerText:
      'You can get the Mylo Onion hair serum (50 ml) for Rs. 159.',
  },
  {
    questionName: 'How to apply a hair serum for dry hair?',
    acceptedAnswerText:
      'Apply a small amount of the anti-frizz hair serum to the palms of your hands. Rub your hands together to evenly distribute the product. Gently work the serum through the lengths and ends of your dry hair, avoiding the roots.',
  },
];
export const onionConditionerDiscussionData = [
  {
    questionName: 'How to use an onion conditioner?',
    acceptedAnswerText:
      'After shampooing, apply the onion conditioner for hair to wet hair. Focus on the lengths and ends, avoiding the scalp. Leave it on for the recommended time mentioned on the product. Rinse thoroughly with water.',
  },
  {
    questionName: 'Which is the best conditioner for hair growth?',
    acceptedAnswerText:
      'The best conditioner for hair fall should contain ingredients like onion, biotin, keratin, tetrapeptides, and vitamins, often promoted for hair growth. Look for products that suit your hair type and preferences.',
  },
  {
    questionName: 'How often can I use a conditioner for dry hair?',
    acceptedAnswerText:
      'You can use a conditioner every time you wash your hair, or as recommended on the product label. Some people with very dry hair may benefit from using a conditioner more frequently.',
  },
  {
    questionName: 'Which is the best conditioner for frizzy hair?',
    acceptedAnswerText:
      'The best hair conditioner for dry or frizzy hair depends on individual preferences. Look for products with ingredients like argan oil, shea butter, or keratin, which are known for their smoothing and moisturizing properties.',
  },
  {
    questionName: 'What is the Mylo hair conditioner price?',
    acceptedAnswerText:
      'You can get Mylo’s onion conditioner (200 ml) for Rs. 249.',
  },
  {
    questionName: 'Is this a chemical-free hair conditioner?',
    acceptedAnswerText:
      'Yes, Mylo’s hair conditioner is chemical-free and doesn’t contain mineral oil, SLS, phthalates, parabens, silicone, artificial preservatives, synthetic colors, and fragrance.',
  },
  {
    questionName: 'Can I use an onion conditioner for hair on my scalp?',
    acceptedAnswerText:
      'Onion conditioners are designed for the lengths and ends of the hair, not the scalp.',
  },
];
const onionHairOilDiscussionData = [
  {
    questionName: 'Is onion oil good for hair?',
    acceptedAnswerText:
      'Yes, onion oil is good for hair. Onion hair oil can be beneficial for hair as it may promote hair growth, strengthen hair, and reduce dandruff.',
  },
  {
    questionName: 'What are the benefits of onion oil for hair?',
    acceptedAnswerText:
      'Onion oil for hair benefits: Onion oil benefits include improving hair texture, preventing hair loss, and nourishing the scalp.',
  },
  {
    questionName: 'How frequently should I apply an onion hair oil?',
    acceptedAnswerText:
      'Applying onion seed oil 1-2 times a week is generally recommended for optimal results.',
  },
  {
    questionName: 'How effective is onion hair oil for hair fall?',
    acceptedAnswerText:
      'Red onion hair oil may be effective for reducing hair fall by strengthening hair follicles and improving scalp health.',
  },
  {
    questionName: 'How to use onion oil for hair growth?',
    acceptedAnswerText:
      'To use onion for hair growth, massage its oil into the scalp, leave it for at least 30 minutes, and then wash it off with a mild shampoo.',
  },
  {
    questionName: 'What is the onion hair oil price?',
    acceptedAnswerText:
      'You can get the Mylo Onion Hair Oil (200 ml) for Rs. 349.',
  },
  {
    questionName: 'Which is the best onion hair oil for hair growth?',
    acceptedAnswerText:
      'If you’re looking for the best onion hair oil, then you can try the Mylo Care Onion Hair Oil. It is fortified with onion seed oil, Amla, Bhringraj, Ylang Ylang, Methi and Vitamin A and D3. Onion hair oil benefits include reducing hair fall, strengthening hair roots, accelerating hair growth and improving scalp health.',
  },
];
const ovolunaDiscussionData = [
  {
    questionName: 'What do ovulation tablets do?',
    acceptedAnswerText:
      'Ovulation booster or tablets support and enhance the ovulation process in women. They help in hormone regulation, egg development and health, menstrual cycle regularity and reproductive health.',
  },
  {
    questionName: 'Which ingredients should fertility tablets have?',
    acceptedAnswerText:
      'Fertility capsules for women should contain ingredients like CoQ10, L-methylfolate, zinc, Vitamin D and B12, etc. Additionally, Ayurvedic herbs like Shatavari can also work wonders in fertility pills.',
  },
  {
    questionName:
      'How is Ovaluna Female Fertility Supplement different from other fertility tablets?',
    acceptedAnswerText:
      'Ovaluna female fertility capsules combine Ayurvedic herbs like Shatavari with scientifically backed ingredients like CoQ10 and L-Methylfolate to improve egg health, folate levels, hormonal balance and reproductive health in women. Unlike other fertility drugs, these FDA-approved fertility capsules have zero side effects and are free from toxins.',
  },
  {
    questionName: 'Is Ovaluna clinically verified?',
    acceptedAnswerText:
      'Yes, Ovaluna female fertility supplement is clinically proven, GMP certified and FDA approved. These fertility capsules are tested for safety, purity and potency to boost the chances of natural conception among women.',
  },
  {
    questionName: 'What are conceive tablets, and how do they work?',
    acceptedAnswerText:
      'Conceive tablets are supplements designed to support fertility in women. They often contain key vitamins and minerals that play a role in reproductive health.',
  },
  {
    questionName:
      'Does egg growth tablet really enhance the growth of eggs during the menstrual cycle?',
    acceptedAnswerText:
      'Egg growth capsules or ovulation tablets contain ingredients that improve egg growth and development. Better egg health can in turn boost the chances of conception and healthy pregnancy.',
  },
  {
    questionName: 'How does ovulation booster help in improving fertility?',
    acceptedAnswerText:
      'They are designed to regulate and enhance the ovulation process, increasing the chances of successful conception. They may contain nutrients that support hormonal balance and reproductive health.',
  },
  {
    questionName: 'Who all can take Ovaluna fertility capsules?',
    acceptedAnswerText:
      "Women diagnosed with menstrual irregularities, PCOS or PCOD, poor egg health, previous failed IUI/IVF attempts and who have been trying to conceive for over a year can consume fertility tablets. However, it's important to consult with a healthcare professional for personalized advice.",
  },
  {
    questionName:
      'How soon can I see the results after taking Ovaluna female fertility capsules?',
    acceptedAnswerText:
      'Our experts recommend that you consume Ovaluna capsules twice daily (1 after breakfast and 1 after dinner) for at least 3 months to see improvement in your reproductive health.',
  },
  {
    questionName:
      'How many tablets are there in one bottle of Ovaluna? And how long will it last?',
    acceptedAnswerText:
      'One bottle of Ovaluna contains 60 capsules. Consume 2 capsules every day and one bottle will last you 30 days, a month’s supply.',
  },
  {
    questionName:
      'Can these conceive tablets be taken with other fertility treatments?',
    acceptedAnswerText:
      "It's important to inform your healthcare provider about any supplements or fertility treatments you are taking to ensure compatibility and avoid potential interactions.",
  },
  {
    questionName: 'Can vegetarians consume Ovaluna fertility supplement?',
    acceptedAnswerText:
      'Yes, these fertility pills are absolutely safe for consumption by vegetarians.',
  },
  {
    questionName:
      'Can women with PCOS/PCOD take the Ovaluna female fertility capsules?',
    acceptedAnswerText:
      'Yes, women clinically identified with PCOS, PCOD or menstrual irregularities can safely consume Ovaluna capsules. These fertility pills can help maintain the menstrual cycle, regulate hormonal balance and boost ovulation.',
  },
  {
    questionName: 'Do I need a prescription to consume these tablets?',
    acceptedAnswerText:
      'No, you don’t need any prescription to consume this fertility supplement.',
  },
];
export const faceMoisturizer = [
  {
    questionName: 'Can I use a vitamin C cream on my face?',
    acceptedAnswerText: 'Yes, you can use a vitamin C face cream.',
  },
  {
    questionName: 'What does a vitamin C moisturizer do?',
    acceptedAnswerText:
      'A vitamin C face moisturizer helps brighten the skin and reduce the appearance of dark spots.',
  },
  {
    questionName: 'Can I use a vitamin C moisturizer for oily skin?',
    acceptedAnswerText:
      'Yes, you can use an oil-free vitamin C moisturizer if you have oily skin as it is non-greasy and helps hydrate the skin.',
  },
  {
    questionName: 'Which is the best vitamin C moisturizer?',
    acceptedAnswerText:
      'If you’re looking for the best vitamin C cream, you should check out Mylo Care Vitamin C Moisturizer, enriched with hyaluronic acid, Vitamin E, white water lily and hydagen aquaporin to brighten complexion, fight free radical damage and nourish the skin.',
  },
  {
    questionName: 'Which is the best moisturizer after vitamin C serum?',
    acceptedAnswerText:
      'The best moisturizer to use after vitamin C serum is a vitamin C face moisturizer as it helps maximize the benefits of vitamin C for your skin, such as brightening complexion and reducing dark spots and pigmentation.',
  },
  {
    questionName: 'Can we use vitamin C moisturizer for dry skin?',
    acceptedAnswerText:
      'Yes, you can use a moisturizer with hyaluronic acid and vitamin C and E and other hydrating ingredients if you have dry skin.',
  },
  {
    questionName: 'Is this an oil-free vitamin C moisturizer?',
    acceptedAnswerText:
      'Yes, the Mylo Care Vitamin C face moisturizer is oil-free and non-greasy.',
  },
  {
    questionName: 'How often should I apply a vitamin C moisturizing cream?',
    acceptedAnswerText:
      'You can apply a vitamin C moisturizer once or twice a day after washing your face.',
  },
  {
    questionName: 'Is this moisturizer with vitamin C and E?',
    acceptedAnswerText:
      'Yes, the Mylo Care Vitamin C cream contains vitamin C and E along with hyaluronic acid, white water lily and hydagen aquaporin.',
  },
  {
    questionName: 'Which is the best vitamin C cream?',
    acceptedAnswerText:
      'If you’re looking for the best vitamin C moisturizer, then check out Mylo Care Vitamin C Face Cream, enriched with hyaluronic acid, Vitamin E, white water lily and hydagen aquaporin to brighten complexion, fight free radical damage and nourish the skin.',
  },
];

export const faceMistData = [
  {
    questionName: 'What’s the best time to use a vitamin C toner?',
    acceptedAnswerText:
      'The best time to use a vitamin C face toner is in the morning, before applying sunscreen.',
  },
  {
    questionName: 'Which is the best toner for oily skin?',
    acceptedAnswerText:
      'The most effective toner for oily skin is one that contains ingredients like green tea or witch hazel to control excess oil and minimize pores.',
  },
  {
    questionName: 'How to choose the best toner for dry skin?',
    acceptedAnswerText:
      'To choose a toner for dry skin, look for hydrating ingredients like cucumber, hyaluronic acid or glycerin.',
  },
  {
    questionName: 'Which is the best toner for glowing skin?',
    acceptedAnswerText:
      'The best face toner to get glowing skin is one that contains exfoliating ingredients like vitamin C, AHAs or BHAs to remove dead skin cells and reveal a brighter complexion.',
  },
  {
    questionName: 'When to use toner, day or night?',
    acceptedAnswerText:
      "A hydrating toner can be used both day and night, but it's especially beneficial at night to remove any remaining impurities.",
  },
  {
    questionName: 'Which is the best toner for sensitive skin?',
    acceptedAnswerText:
      'The best toner for sensitive skin is one that is alcohol-free and contains soothing ingredients like chamomile or cucumber like the Mylo Care Vitamin C toner.',
  },
  {
    questionName: 'What are some vitamin C toner benefits?',
    acceptedAnswerText:
      'The benefits of using a vitamin C toner include brightening the skin, reducing hyperpigmentation, and boosting collagen production.',
  },
  {
    questionName: 'Can we use vitamin C toner for oily skin?',
    acceptedAnswerText:
      'Yes, a vitamin C face toner is the best toner for oily skin as it helps control sebum production and reduce inflammation.',
  },
  {
    questionName: 'Which is the best toner in India?',
    acceptedAnswerText:
      'If you’re looking for the best face toner, then do consider the Mylo Care Mattifying Vitamin C Toner with witch hazel, green tea and cucumber.',
  },
  {
    questionName: 'How often can I use a vitamin C face mist?',
    acceptedAnswerText:
      'You can use it 1-2 times a day to refresh your face and get rid of extra oil.',
  },
];

export const faceWashData = [
  {
    questionName: 'Can we use a vitamin C face wash daily?',
    acceptedAnswerText: 'Yes, you can use a natural vitamin C face wash daily.',
  },
  {
    questionName: 'What are some vitamin C face wash benefits?',
    acceptedAnswerText:
      'The benefits of vitamin C face wash include brightening the skin, reducing hyperpigmentation, and promoting collagen production.',
  },
  {
    questionName: 'How to choose the best vitamin C face wash?',
    acceptedAnswerText:
      'To choose the best vitamin C face wash in India, look for a product with a high concentration of vitamin C and other beneficial ingredients.',
  },
  {
    questionName: 'How to use a vitamin C foaming face wash?',
    acceptedAnswerText:
      'To use a vit C face wash, wet your face, apply the cleanser, and massage gently in circular motions before rinsing.',
  },
  {
    questionName: 'Is it okay to use vitamin C face wash for oily skin?',
    acceptedAnswerText:
      'Yes, it is okay to use a vitamin C face wash if you have oily skin as it helps control sebum production and unclogs pores.',
  },
  {
    questionName: 'Can we use vitamin C face wash for dry skin?',
    acceptedAnswerText:
      'Yes, you can use a natural vitamin C face wash if you have dry skin as it helps hydrate and nourish the skin.',
  },
  {
    questionName: 'What is the Mylo Care vitamin C face wash price?',
    acceptedAnswerText:
      'You can get the best vitamin C face wash from Mylo at Rs 239.',
  },
  {
    questionName: 'Is this a natural vitamin C face wash?',
    acceptedAnswerText:
      'Yes, it is free from toxins and harmful chemicals like soap, SLS, paraben, phthalates, mineral oil and synthetic colours.',
  },
  {
    questionName: 'How often should I use a vitamin C brightening face wash?',
    acceptedAnswerText:
      'To maximise vitamin C face wash benefits, you can use it daily and follow it with Mylo Care Vitamin C Toner and Mylo Care Vitamin C Moisturizer.',
  },
  {
    questionName: 'Which is the best vitamin C face wash in India?',
    acceptedAnswerText:
      'If you’re looking for the best vitamin C face wash, then do try the Mylo Care Vitamin C Face Wash with AHA, aloe vera and green tea that brightens skin complexion, gently removes skin impurities and nourishes and moisturizes the skin.',
  },
];
export const faceSerumData = [
  {
    questionName: 'Is vitamin C serum good for skin?',
    acceptedAnswerText:
      'Yes, vitamin C serum is good for the skin, providing antioxidant protection, promoting collagen synthesis and brightening skin tone.',
  },
  {
    questionName: 'What does vitamin C serum do?',
    acceptedAnswerText:
      'Using a Vitamin C serum for face helps brighten skin, reduce hyperpigmentation, and combat free radical damage.',
  },
  {
    questionName: 'How to apply vitamin C serum?',
    acceptedAnswerText:
      'Apply natural vitamin C serum to clean, dry skin before moisturizing, using a few drops and gently massaging it in.',
  },
  {
    questionName: 'Which is the best vitamin C serum?',
    acceptedAnswerText:
      'If you’re looking for the best vitamin C serum in India, you should consider using Mylo Care’s Vitamin C and Hyaluronic Acid Serum, which reduces visible dark spots, patchy skin & evens out skin tone, and is a perfect face serum for glowing skin.',
  },
  {
    questionName: 'What are some vitamin C serum for face benefits?',
    acceptedAnswerText:
      'Vitamin C serum benefits include improved skin brightness, reduced fine lines, and protection against environmental damage. So, choose the best vitamin C serum for face with Mylo Care and give your skin these benefits.',
  },
  {
    questionName: 'Are there any vitamin C serum side effects?',
    acceptedAnswerText:
      'While rare, vitamin C serum may cause potential side effects like irritation or redness. It’s important to patch test before regular use.',
  },
  {
    questionName: 'What is the Mylo Care vitamin C serum price?',
    acceptedAnswerText:
      'You can get the Mylo Care Vitamin C serum for face for Rs 499.',
  },
  {
    questionName: 'Can we use this vitamin C serum for men?',
    acceptedAnswerText:
      'Yes, you can use the best vitamin C serum for men and it will provide similar benefits for their skin.',
  },
  {
    questionName: 'Can I use this vitamin C serum for dry skin?',
    acceptedAnswerText:
      'Yes, you can use the best vitamin C serum for dry skin as it helps hydrate and promote collagen production.',
  },
  {
    questionName: 'How to choose the best vitamin C serum for sensitive skin?',
    acceptedAnswerText:
      'To choose the best vitamin C serum, opt for a formulation with lower concentrations, free of potential irritants, and patch test first.',
  },
  {
    questionName: 'How effective is vitamin C serum for pigmentation?',
    acceptedAnswerText:
      'The best vitamin C serum for pigmentation can help to lighten dark spots and even out skin tone. You can also use the best vitamin C serum for hyperpigmentation.',
  },
  {
    questionName: 'Can I use vitamin C serum for skin whitening?',
    acceptedAnswerText:
      'While not specifically vitamin C for skin whitening, vitamin C serum may contribute to a brighter complexion by reducing hyperpigmentation.',
  },
  {
    questionName: 'Can we use vitamin C serum for oily skin?',
    acceptedAnswerText:
      'The best vitamin C serum for oily skin can help regulate oil production, has antioxidant properties that combat free radicals, and promotes collagen synthesis, contributing to a healthier complexion.',
  },
];

const vitaminBodyWash = [
  {
    questionName: 'What are the benefits of using a vitamin C body wash?',
    acceptedAnswerText:
      'Benefits of using a vitamin C-infused body wash include antioxidant protection, reduction in pigmentation and brighter, more even skin tone.',
  },
  {
    questionName: 'How effective is this body wash for dark spots?',
    acceptedAnswerText:
      'Mylo Care Vitamin C body wash can be effective for dark spots and pigmentation, helping to lighten and even out skin tone.',
  },
  {
    questionName: 'Which is the best body wash for glowing skin?',
    acceptedAnswerText:
      'If you’re looking for a body wash for glowing skin, then opt for brightening ingredients like Vitamin C, honey, aloe vera etc.',
  },
  {
    questionName: 'How often can I use a whitening body wash?',
    acceptedAnswerText:
      'Usage frequency for skin whitening body wash depends on the product; follow the recommended guidelines, typically 2-3 times per week.',
  },
  {
    questionName:
      'Can I use a skin brightening body wash if I have sensitive skin?',
    acceptedAnswerText:
      'As long as the body wash doesn’t have any harmful toxins or chemicals like sulphates, mineral oil etc. It should be safe for sensitive skin. Remember to check for sensitive skin formulation before buying a body wash.',
  },
  {
    questionName: 'Is this a brightening body wash?',
    acceptedAnswerText:
      'Yes, Mylo Vitamin C body wash can help brighten and nourish the skin naturally. It can even help reduce pigmentation.',
  },
  {
    questionName: 'Which is the best body wash for skin whitening?',
    acceptedAnswerText:
      'If you’re looking for a skin whitening body wash, then look for ingredients like Vitamin C, arbutin or licorice extract.',
  },
  {
    questionName:
      'Is Mylo Care Vitamin C Body Wash suitable for all skin types?',
    acceptedAnswerText:
      'Yes, you can use this body wash for all skin types whether you have dry, oily or sensitive skin.',
  },
];

const vitaminBodyLotion = [
  {
    questionName: 'What are the benefits of using a Vitamin C Body Lotion?',
    acceptedAnswerText:
      'Vitamin C lotion can help brighten skin, reduce hyperpigmentation, and boost collagen production for a healthier complexion.',
  },
  {
    questionName: 'Which is the best Vitamin C Body Lotion?',
    acceptedAnswerText:
      'If you’re looking for the best body lotion with vitamin C, then you can consider Mylo Care Vitamin C Body Lotion with shea butter, olive oil, hydagen aquaporin and niacinamide. It provides deep moisturization, evens out skin tone, nourishes skin and soothes irritation.',
  },
  {
    questionName: 'Which is the best body lotion for glowing skin?',
    acceptedAnswerText:
      'If you want to achieve glowing skin, then you should look for a body lotion with ingredients like Vitamin C, niacinamide, AHAs etc.',
  },
  {
    questionName: 'Which is the best skin whitening body lotion?',
    acceptedAnswerText:
      'If you’re looking for a skin whitening body lotion, consider products containing ingredients like vitamin C, niacinamide, alpha-arbutin, kojic acid, or licorice extract.',
  },
  {
    questionName: 'How often should I use a brightening body lotion?',
    acceptedAnswerText:
      'You can use brightening body lotion 2-3 times a week for optimal results, adjusting frequency based on individual skin sensitivity and product instructions.',
  },
  {
    questionName: 'Can I use vitamin C lotion if I have sensitive skin?',
    acceptedAnswerText:
      "Vitamin C body lotion can be used on sensitive skin, but it's advisable to patch-test first and choose a formulation with lower concentrations or additional soothing ingredients.",
  },
  {
    questionName: 'How to choose the best skin whitening body lotion?',
    acceptedAnswerText:
      'Choose a skin whitening body lotion by considering your skin type, specific concerns, and looking for ingredients like niacinamide, vitamin C, or natural extracts with skin-brightening properties.',
  },
  {
    questionName:
      'What are the ingredients of Mylo Care Vitamin C Body Lotion?',
    acceptedAnswerText:
      'Mylo Care Vitamin C Lotion contains shea butter, olive oil, niacinamide, hydagen aquaporin and Vitamin C.',
  },
];

const vitaminCombo = [
  {
    questionName: 'What are the benefits of using a Vitamin C skin care kit?',
    acceptedAnswerText:
      'A Vitamin C kit can promote collagen production, reduce dark spots, and provide antioxidant protection for healthier skin.',
  },
  {
    questionName: 'How to use a cleanser toner moisturizer kit?',
    acceptedAnswerText:
      'Apply cleanser to clean skin, follow with toner to balance, and finish with moisturizer to hydrate in a daily skin care routine kit.',
  },
  {
    questionName: 'Can I use a face care kit every day?',
    acceptedAnswerText:
      'Yes, face care kits are designed for daily use to maintain a consistent skincare routine.',
  },
  {
    questionName: 'Is a Vitamin C kit okay for sensitive skin?',
    acceptedAnswerText:
      "Vitamin C skin care kit is generally suitable for sensitive skin, but it's advisable to do a patch test first.",
  },
  {
    questionName: 'Which is the best cleanser toner moisturizer kit?',
    acceptedAnswerText:
      'If you’re looking for a cleanser toner moisturizer kit, then do check out Mylo Vitamin C Skin Care Kit, which has Vitamin C Face Wash, Vitamin C Toner and Vitamin C Face Moisturizer for a daily skincare regime.',
  },
  {
    questionName: 'What all products should a daily skin care kit have?',
    acceptedAnswerText:
      'A daily face care kit should include a cleanser, toner, moisturizer, sunscreen, and, if needed, specialized treatments like serums or eye creams.',
  },
];
export const ubtanFaceWashData = [
  {
    questionName: 'Can I use Ubtan face wash every day?',
    acceptedAnswerText:
      'Yes, the Mylo Care Ubtan and saffron face wash can be used every day for gentle cleansing.',
  },
  {
    questionName: 'What are the benefits of applying Ubtan as a face wash?',
    acceptedAnswerText:
      'Ubtan face wash benefits include exfoliation, brightening, and promoting healthy skin.',
  },
  {
    questionName: 'Does Ubtan remove tan?',
    acceptedAnswerText:
      'Yes, Ubtan helps in removing tan and brightening the skin.',
  },
  {
    questionName: 'Is this a tan removal face wash?',
    acceptedAnswerText:
      'Yes, the Mylo Care Ubtan, saffron & turmeric face wash is designed for tan removal.',
  },
  {
    questionName: 'Should I use an Ubtan soap or a face wash?',
    acceptedAnswerText:
      'If you want a face wash that cleanses gently, you should use an Ubtan face wash.',
  },
  {
    questionName: 'Is an Ubtan foaming face wash better or non-foaming?',
    acceptedAnswerText:
      'Both types are effective; you can choose based on personal preference for texture. However, a non-foaming Ubtan facewash may be more gentle on the skin.',
  },
  {
    questionName: 'Which is the best tan removal face wash?',
    acceptedAnswerText:
      'The best face wash for tanned skin in India should have ingredients that help remove tan and brighten the skin such as saffron, turmeric, licorice and almonds. If you’re looking for the best face wash for tanned skin, then you should try the Mylo Care Ubtan Face Wash with turmeric, saffron, licorice, almonds and hydagen aquaporin that helps remove tan, brightens the skin and exfoliates gently.',
  },
  {
    questionName: 'What are the benefits of using a turmeric face wash?',
    acceptedAnswerText:
      'Using a face wash enriched with turmeric can help remove skin tanning, soothe skin irritation and brighten the skin.',
  },
  {
    questionName: 'What is the Mylo Care Ubtan face wash review?',
    acceptedAnswerText:
      'The Mylo Care Ubtan Face wash is rated 4.2 out of 5 stars and is well-liked by users who often regard it as an effective tan removal face wash.',
  },
  {
    questionName: 'How to choose a tan removal face wash for oily skin?',
    acceptedAnswerText:
      'The best tan removal face wash for oily skin is one which exfoliates gently and keeps the skin hydrated in order to curb excess sebum production.',
  },
  {
    questionName: 'Which is the best facewash for tan?',
    acceptedAnswerText:
      'The best face wash for tanned skin should contain ingredients which are effective in removing tan and brightening the skin like turmeric, saffron, licorice and almonds.',
  },
  {
    questionName: 'What is the Mylo Care Ubtan Face Wash price?',
    acceptedAnswerText:
      'You can get the Mylo Care Ubtan Face Wash 100 gm for just Rs 239.',
  },
];

export const ubtanBodyWashData = [
  {
    questionName: 'Can I use an Ubtan Body Wash daily?',
    acceptedAnswerText:
      'Yes, Body Ubtan Wash can be used daily for a refreshing cleansing experience.',
  },
  {
    questionName: 'Is this a tan removal body wash?',
    acceptedAnswerText:
      'Yes, our body wash is formulated with turmeric, saffron and sandalwood to help in tan removal and promote skin radiance.',
  },
  {
    questionName: 'Can you suggest an alternative for body Ubtan?',
    acceptedAnswerText:
      'If you don’t have the time to apply Ubtan on your body but still want its benefits, then you can invest in an Ubtan body wash and body lotion.',
  },
  {
    questionName: 'Which is the best tan removal body wash?',
    acceptedAnswerText:
      'If you’re looking for the best tan removal body wash in India, then you can try the Mylo Care Ubtan Body Wash with turmeric, saffron, sandalwood and hydagen aquaporin that helps to remove tanning, reduce pigmentation, relax the body and moisturize it for 24 hours.',
  },
  {
    questionName: 'How to choose a body wash for pigmentation?',
    acceptedAnswerText:
      'If you’re looking for a body wash for hyperpigmentation, then look for a body wash with ingredients like saffron, turmeric, Vitamin C or glycolic acid that target and address pigmentation concerns.',
  },
  {
    questionName: 'What are the benefits of using an Ayurvedic body wash?',
    acceptedAnswerText:
      'A body wash with Ayurvedic formulation and natural ingredients can help soothe and nourish the skin, provide a gentle cleansing experience and save your skin from chemicals and their side effects.',
  },
  {
    questionName: 'Is this a moisturizing body wash?',
    acceptedAnswerText:
      'Yes, the Mylo Care Ubtan, turmeric, saffron and sandalwood body wash is formulated with hydagen aquaporin, a clinically tested ingredient for 24 hours moisturization.',
  },
  {
    questionName: 'What is the Mylo Care Ubtan body wash price?',
    acceptedAnswerText:
      'You can buy the Mylo Care Ubtan body wash (275 ml) for Rs. 289.',
  },
];
export const ubtanBodyLotionData = [
  {
    questionName: 'What are the benefits of using an Ubtan body lotion?',
    acceptedAnswerText:
      'An ubtan body lotion can help repair and soothe irritated skin, brighten the skin complexion, even out the skin tone and moisturize the skin.',
  },
  {
    questionName: 'Can I use this body lotion for tan removal?',
    acceptedAnswerText:
      'Yes, you can use this as a tan removal body lotion as it contains turmeric, which helps to remove tanning and improve overall complexion.',
  },
  {
    questionName: 'Is this a good body lotion for pigmentation?',
    acceptedAnswerText:
      'Yes, it’s a great body lotion for hyperpigmentation as it contains saffron, which helps to reduce pigmentation and even out the skin tone.',
  },
  {
    questionName: 'How to choose the best body lotion for tan removal?',
    acceptedAnswerText:
      'An effective de tan body lotion should have ingredients like turmeric, saffron, aloe vera and Vitamin C to remove tanning and brighten the skin complexion.',
  },
  {
    questionName: 'Is this a shea butter body lotion?',
    acceptedAnswerText:
      'Yes, it contains shea butter along with cocoa butter, turmeric, saffron and hydagen aquaporin to repair and soothe irritated skin, brighten the skin complexion, even out the skin tone and moisturize the skin for up to 24 hours.',
  },
  {
    questionName: 'Which is the best body lotion for all skin types?',
    acceptedAnswerText:
      'The best body lotion for all skin types should be one with no harmful chemicals, toxins or irritants, that’s hydrating and enriched with natural ingredients.',
  },
  {
    questionName: 'What is the Mylo Care Ubtan body lotion price?',
    acceptedAnswerText:
      'You can buy the Mylo Care Ubtan Body Lotion (275 ml) for Rs. 249.',
  },
  {
    questionName: 'How often can I use this tan removal body lotion?',
    acceptedAnswerText:
      'You can use this body lotion for tan removal at least once every day, preferably after a shower to allow the skin to absorb its goodness.',
  },
];
export const ubtanComboData = [
  {
    questionName: 'What’s in this Ubtan Combo?',
    acceptedAnswerText:
      'The Mylo Care Ubtan Combo contains one Ubtan Body Wash (275 ml) and one Ubtan Body Lotion (275 ml).',
  },
  {
    questionName:
      'What is the price of the Mylo Care Ubtan Body Wash and Body Lotion Combo?',
    acceptedAnswerText:
      'You can get the Mylo Care Ubtan Body Wash and Body Lotion Combo offer at just Rs. 556.',
  },
  {
    questionName: 'What are the benefits of using Ubtan body wash with lotion?',
    acceptedAnswerText:
      'Using our Ubtan body wash and body lotion combo can help remove tan, exfoliate gently, make the skin glow and provide up to 24 hours moisturization.',
  },
  {
    questionName: 'Is this suitable for all skin types?',
    acceptedAnswerText:
      'Yes, our Ubtan body lotion and body wash combo is suitable for all skin types.',
  },
  {
    questionName: 'Can I use the Ubtan body wash daily?',
    acceptedAnswerText: 'Yes, you can use it every day.',
  },
  {
    questionName: 'What is the best time to apply Ubtan body lotion?',
    acceptedAnswerText:
      'For best results, you should apply it shortly after bathing so the skin can lock in the moisture and absorb its goodness.',
  },
];

export const teaTreeFashWash = [
  {
    questionName: 'How often can I use a tea tree face wash?',
    acceptedAnswerText:
      'You can use a tea tree oil face wash 1-2 times daily for optimal results.',
  },
  {
    questionName: 'What are the uses of a tea tree cleanser?',
    acceptedAnswerText:
      'Tea tree facewash can help treat acne, control oil, and promote clearer skin.',
  },
  {
    questionName: 'Is tea tree an effective ingredient in acne face wash?',
    acceptedAnswerText:
      'Yes, tea tree is a very effective ingredient in anti acne face wash due to its antibacterial properties.',
  },
  {
    questionName: 'How should I use a face wash for pimples?',
    acceptedAnswerText:
      'Apply a face wash for pimples and acne twice daily, gently massaging onto damp skin. After rinsing it with water, follow with a good moisturizer.',
  },
  {
    questionName: 'Which is the best face wash for acne?',
    acceptedAnswerText:
      'If you’re looking for the best face for acne and pimples, then look for a face wash with acne-fighting ingredients like tea tree, salicylic acid, benzoyl peroxide, neem etc. You can also try the Mylo Care Tea Tree Face Wash, enriched with tea tree, neem, magnolia and glycolic acid that helps relieve acne, unclog the pores, prevent bacterial invasion and soothe irritated skin.',
  },
  {
    questionName: 'What are the tea tree face wash benefits?',
    acceptedAnswerText:
      'Tea tree oil face wash benefits include fighting acne, reducing inflammation, and providing a refreshing feel.',
  },
  {
    questionName:
      'What ingredients should a face wash for acne prone skin have?',
    acceptedAnswerText:
      'The best face wash for acne prone skin should have ingredients like tea tree, salicylic acid, benzoyl peroxide, and glycolic acid.',
  },
  {
    questionName: 'Which face wash is best for pimples?',
    acceptedAnswerText:
      'The best face wash for pimples should be gentle on the skin, exfoliate it without causing any abrasion, remove oil and unclog the pores and contain acne-fighting ingredients like tea tree, salicylic acid, benzoyl peroxide and neem.',
  },
  {
    questionName:
      'Is a tea tree foaming face wash better than a non-foaming one?',
    acceptedAnswerText:
      'It’s up to you whether you want to use a foaming face wash or a non-foaming one.',
  },
  {
    questionName:
      'What ingredients should a face wash for oily skin and pimples have?',
    acceptedAnswerText:
      'A face wash for oily acne prone skin should have ingredients like tea tree, salicylic acid, glycolic acid, neem and witch hazel.',
  },
  {
    questionName:
      'How soon can I expect results from the best face wash for acne and pimples?',
    acceptedAnswerText:
      'Results from the best face wash for pimples can vary but you should notice some improvement within a few weeks.',
  },
  {
    questionName: 'What are the benefits of neem and tea tree face wash?',
    acceptedAnswerText:
      'The benefits of using a neem tea tree face wash include antibacterial action and soothing effects on the skin.',
  },
  {
    questionName: 'Can I use an anti acne face wash every day?',
    acceptedAnswerText:
      'Yes, you can use an acne face wash daily if it suits your skin.',
  },
  {
    questionName: 'How effective is tea tree face wash for acne?',
    acceptedAnswerText:
      'When it comes to choosing an acne control face wash, tea tree is considered a highly effective ingredient due to its antimicrobial and anti-inflammatory properties. Tea tree face wash benefits include fighting acne, reducing inflammation, and providing a refreshing feel.',
  },
  {
    questionName: 'Which is the best face wash for acne and pimples in India?',
    acceptedAnswerText:
      'If you’re looking for the best face wash for acne prone skin in India, you can consider Mylo Care Tea Tree Face Wash. It is enriched with tea tree, neem, magnolia and glycolic acid that helps relieve acne, unclog the pores, prevent bacterial invasion and soothe irritated skin.',
  },
  {
    questionName: 'Is it okay to use tea tree face wash for oily skin?',
    acceptedAnswerText:
      'Yes, a tea tree oil face wash is suitable for oily skin due to its ability to control excess oil production.',
  },
  {
    questionName: 'What is the Mylo Care tea tree face wash review?',
    acceptedAnswerText:
      'The Mylo Care Tea Tree Cleanser is rated 4.2 out of 5 stars when it comes to customer reviews. Users like it for its effect on acne and pimples, its fragrance, texture and value for money.',
  },
  {
    questionName:
      'Will a face wash for oily acne prone skin help remove blackheads too?',
    acceptedAnswerText:
      'A face wash for acne prone skin can help remove blackheads too by removing excess oil and unclogging the pores.',
  },
  {
    questionName: 'Does an acne removal face wash make the skin dry?',
    acceptedAnswerText:
      'An acne clear face wash may dry out the skin, which is why it’s important to follow it with a moisturizer to counteract this effect or look for an acne free face wash that contains moisturizing ingredients.',
  },
  {
    questionName: 'Which is the best face wash for acne and dark spots?',
    acceptedAnswerText:
      'The best face wash for acne scars and dark spots should contain ingredients like tea tree, alpha arbutin or glycolic acid.',
  },
  {
    questionName: 'Which is the best tea tree face wash?',
    acceptedAnswerText:
      'While there’s a wide variety of tea tree infused face washes in the market, you can consider using the Mylo Care Tea Tree Facewash. Our best face wash for acne is enriched with tea tree, neem, magnolia and glycolic acid that helps relieve acne, unclog the pores, prevent bacterial invasion and soothe irritated skin.',
  },
];
export const teaTreeFaceMask = [
  {
    questionName: 'Is it safe to use tea tree oil for face?',
    acceptedAnswerText:
      "It is generally safe to use tea tree for skin, including the face when used in diluted form. It has antimicrobial properties that may be beneficial for various skin concerns. However, it's important to perform a patch test to check for any adverse reactions and to dilute it with a carrier oil before applying to the face.",
  },
  {
    questionName: 'What are some tea tree benefits for face?',
    acceptedAnswerText:
      'Tea tree oil benefits for skin include its antimicrobial properties that help combat acne-causing bacteria and reduce inflammation, promoting clearer skin. Its natural astringent qualities also assist in controlling excess oil production, making it beneficial for managing oily skin.',
  },
  {
    questionName: 'How often can I apply a tea tree face mask?',
    acceptedAnswerText:
      'The frequency of application depends on your skin type and sensitivity. For most people, using a tea tree face pack once or twice a week is a good starting point. Monitor how your skin responds and adjust accordingly.',
  },
  {
    questionName: 'How effective is tea tree face mask for acne?',
    acceptedAnswerText:
      "Tea tree face masks can be effective for acne due to tea tree oil's antimicrobial and anti-inflammatory properties. It may help reduce acne-causing bacteria and inflammation on the skin.",
  },
  {
    questionName: 'Which is the best tea tree mask?',
    acceptedAnswerText:
      'If you’re looking for an effective tea tree mask, then you can also consider Mylo Care Tea Tree Face Mask. It is infused with Australian tea tree, multani mitti, basil and glycolic acid, combined these ingredients help relieve acne, remove dead skin cells, soothe irritated skin, and exfoliate and brighten the skin.',
  },
  {
    questionName: 'Can I use this face mask for pimples?',
    acceptedAnswerText:
      'Yes, you can without a doubt use this face mask for pimples and dark spots as tea tree can help reduce the occurrence of pimples and promote clearer skin.',
  },
  {
    questionName: 'How effective is this face mask for blackheads?',
    acceptedAnswerText:
      'Tea tree face masks can be effective against blackheads by helping to control excess oil and prevent bacterial growth.',
  },
  {
    questionName: 'Is it safe to use this face mask for sensitive skin?',
    acceptedAnswerText:
      'While there are numerous tea tree oil benefits for skin, it may be too strong for some individuals with sensitive skin. Always perform a patch test before using a tea tree mask and consider diluting it further with a gentle carrier oil.',
  },
  {
    questionName:
      'How often should I use a face mask for pimples and dark spots?',
    acceptedAnswerText:
      'Using a face mask once or twice a week can be a good starting point. Consistency is key, and you may adjust the frequency based on how your skin responds.',
  },
  {
    questionName: 'What ingredients are there in tea tree clay mask?',
    acceptedAnswerText:
      'Ingredients in a tea tree clay mask can vary, but common components may include tea tree oil, clay (such as kaolin, fuller earth or bentonite), water or aloe vera gel, carrier oils and additional skin-friendly ingredients like neem or basil.',
  },
];

export const teaTreeFaceCream = [
  {
    questionName:
      'What ingredients should be there in a face cream for oily skin?',
    acceptedAnswerText:
      'A face moisturizer for oily skin should contain ingredients like tea tree, salicylic acid, niacinamide, and hyaluronic acid.',
  },
  {
    questionName: 'Which is the best face moisturizer for oily skin?',
    acceptedAnswerText:
      'The best face moisturizer for oily skin is often water-based, non-comedogenic, and oil-free, like the Mylo Care Tea Tree Face Cream. It is enriched with Australian tea tree, hyaluronic acid, glycolic acid and hydagen aquaporin that helps relieve acne, provide intense hydration to the skin and exfoliate the skin gently.',
  },
  {
    questionName: 'Is it okay to use tea tree moisturizer for oily skin?',
    acceptedAnswerText:
      'Using a tea tree moisturizer is generally okay for oily skin as tea tree oil has natural antimicrobial properties and helps detoxify the skin.',
  },
  {
    questionName: 'What are some tea tree cream for face benefits?',
    acceptedAnswerText:
      'Tea tree face cream benefits include acne control, reduction of inflammation, and soothing irritated skin.',
  },
  {
    questionName: 'How often should I use a tea tree cream?',
    acceptedAnswerText:
      'You can use it once daily but avoid excessive application to prevent skin irritation.',
  },
  {
    questionName:
      'Should I do a patch test before using tea tree cream for face?',
    acceptedAnswerText:
      "It's advisable to do a patch test before using tea tree cream for face to check for any adverse reactions.",
  },
  {
    questionName: 'Can I use this face cream for sensitive skin?',
    acceptedAnswerText:
      'Yes, you can use the Mylo Care Tea Tree Cream as it is suitable for all skin types and doesn’t contain chemicals like parabens, mineral oil, phthalates and silicone.',
  },
  {
    questionName: 'Is tea tree face cream an antifungal face cream?',
    acceptedAnswerText:
      'Yes, tea tree does have antifungal properties, making it beneficial for certain skin conditions.',
  },
  {
    questionName:
      'What are the benefits of applying tea tree moisturizer for oily skin?',
    acceptedAnswerText:
      'Tea tree cream for face benefits include oil control, acne prevention, and a matte finish.',
  },
  {
    questionName: 'Is this an effective face cream pimples?',
    acceptedAnswerText:
      'Yes, it is an effective face cream for pimples and black spots as it contains tea tree, glycolic acid and hyaluronic acid. These ingredients help relieve acne, exfoliate gently and hydrate the skin.',
  },
  {
    questionName: 'Is this face cream hydrating?',
    acceptedAnswerText:
      'Yes, our face cream with hyaluronic acid provides intense hydration to the skin. It also contains hydagen aquaporin, which ensures hydration up to 24 hours.',
  },
  {
    questionName: 'Can I use this face cream for pimples and black spots?',
    acceptedAnswerText:
      'Yes, you can use our tea tree cream for face, which helps address both pimples and black spots.',
  },
  {
    questionName: 'Is this face cream with glycolic acid?',
    acceptedAnswerText:
      'Yes, our tea tree moisturizer contains glycolic acid which helps to exfoliate the skin and brighten it.',
  },
  {
    questionName: 'Which is the best face moisturizer for sensitive skin?',
    acceptedAnswerText:
      'The best face moisturizer for sensitive skin may be fragrance-free, hypoallergenic, and gentle, such as the Mylo Care Tea Tree Moisturizer for oily skin which is suitable for all skin types.',
  },
];
const breastPumpFaqs = [
  {
    questionName: 'Is it safe to use an electric breast pump?',
    acceptedAnswerText:
      "Yes, it is absolutely safe to use an electric breast milk pump when used according to the manufacturer's instructions.",
  },
  {
    questionName: 'What are the benefits of using an automatic breast pump?',
    acceptedAnswerText:
      'Automatic breast milk pump offers convenience, efficiency, and flexibility, allowing mothers to express milk more comfortably and in less time.',
  },
  {
    questionName:
      'What factors should I keep in mind to select the best electric breast pump?',
    acceptedAnswerText:
      'When selecting the best electric breast pump India, consider factors such as suction strength, adjustable settings, portability, ease of cleaning, and compatibility with your lifestyle and breastfeeding needs.',
  },
  {
    questionName:
      'Are there any electric breast pump side effects I should know about?',
    acceptedAnswerText:
      'While rare, potential side effects of using an electric breast pump may include discomfort, nipple irritation, or improper milk expression technique.',
  },
  {
    questionName: 'Where can I find an electric breast pump near me?',
    acceptedAnswerText:
      'If you’re looking for an electric breast pump India, you can purchase it online as it allows you the convenience of browsing a wide variety of brands, reading customer reviews and detailed product descriptions, getting doorstep delivery and exciting deals and discounts.',
  },
  {
    questionName: 'Which is the best electric breast pump India?',
    acceptedAnswerText:
      "If you’re looking for the best breast pump in India, Mylo Baby offers electric breast pump with 9 level intensity adjustment, 3 phase pumping system, which mimics baby’s natural suction. Our 100% BPA-free baby feeding pump features a built-in memory function that conveniently stores mom's preferred pumping style settings, ensuring ease of use in each session. The pump's display is user-friendly, featuring a timer to monitor each session, while the pause and start buttons facilitate seamless adjustments during pumping sessions.",
  },
  {
    questionName: 'What is the Mylo Baby Electric Breast Pump price?',
    acceptedAnswerText:
      'The Mylo Baby breast milk electric pump price is Rs 3199. You can avail further discounts at the Mylo App.',
  },
  {
    questionName: 'What is the average electric pump for breast milk price?',
    acceptedAnswerText:
      'The average price of an electric breast pump can range from budget-friendly options around Rs 2000 to higher-end models with additional features costing Rs 20,000.',
  },
  {
    questionName: 'How often can I use an electric breast milk pump?',
    acceptedAnswerText:
      'It is generally safe to use an electric, hands free breast pump as often as needed, but individual pumping frequency may vary based on breastfeeding goals and milk supply.',
  },
  {
    questionName: 'Is an automatic breast milk pump painful?',
    acceptedAnswerText:
      'When used correctly, an automatic breast pump should not be painful, but some women may experience discomfort if the pump is not properly adjusted or fitted.',
  },
  {
    questionName:
      'Out of manual and electric, which is the best breast pump in India?',
    acceptedAnswerText:
      'The best breast pump depends on individual preferences, with electric pumps offering more convenience and efficiency, while manual pumps are often more portable and cost-effective.',
  },
  {
    questionName: 'Is silicone breast pump safe to use?',
    acceptedAnswerText:
      "Silicone baby feeding pumps are generally considered safe to use and are often used for collecting let-down milk during breastfeeding, but it's important to follow proper cleaning and usage guidelines for safety.",
  },
];
export const stretchMarksFAQsData = [
  {
    questionName: 'How often should I use this stretch mark cream?',
    acceptedAnswerText:
      'It is suggested to use the stretch mark removal cream twice a day - once in the morning and once at night.',
  },
  {
    questionName: 'How to choose the best stretch mark removal cream?',
    acceptedAnswerText:
      'When it comes to choosing the best stretch mark cream, look for creams containing ingredients like vitamin E, almond, striover, shea butter, grape, or ceramics, and avoid urea, essential oils, salicylic acid, or retinoids.',
  },
  {
    questionName:
      'Is it safe to use a stretch marks removal cream during pregnancy?',
    acceptedAnswerText:
      "It is generally considered safe to use a stretch marks cream during pregnancy, but it's recommended to consult with a doctor before using any skincare product.",
  },
  {
    questionName: 'Which is the best stretch mark cream during pregnancy?',
    acceptedAnswerText:
      'The best stretch mark cream for pregnancy is one which doesn’t contain ingredients that may harm the expecting mother or her baby like silicone, artificial fragrance, paraben or mineral oil. Additionally, a pregnancy stretch marks removal cream should have natural and safe ingredients like coconut oil, shea butter, saffron etc.',
  },
  {
    questionName: 'Is this a pregnancy stretch mark cream?',
    acceptedAnswerText:
      'Yes, the Mylo Care stretch mark cream is safe for use during pregnancy and breastfeeding. It is Made Safe-certified and helps remove pregnancy stretch marks.',
  },
  {
    questionName: 'Can we use this stretch mark cream for men?',
    acceptedAnswerText:
      'Yes, this anti stretch mark cream is designed to work on men and women of all ages and all skin types.',
  },
  {
    questionName: 'Can I use this cream for stretch marks after pregnancy?',
    acceptedAnswerText:
      'Yes, you can use it as a post pregnancy stretch marks cream to help improve the texture and appearance of stretch marks.',
  },
  {
    questionName:
      'How soon can I start using a stretch marks removal cream after delivery?',
    acceptedAnswerText:
      'You can start using a post pregnancy stretch marks cream from day one after delivery as long as it is certified safe for use during breastfeeding and with your doctor’s approval.',
  },
  {
    questionName:
      'Can this anti stretch mark cream help in preventing stretch marks?',
    acceptedAnswerText:
      'By using this stretch marks cream during pregnancy from the second trimester itself, you can help prevent the appearance of stretch marks.',
  },
  {
    questionName:
      'Which is the best stretch mark removal cream after delivery?',
    acceptedAnswerText:
      'If you’re looking for the best cream for stretch marks after pregnancy, then look for a cream containing safe ingredients like vitamin E, almond, coconut oil, shea butter, striover, grape, or ceramic.',
  },
  {
    questionName: 'Which is the best stretch mark removal cream in India?',
    acceptedAnswerText:
      'If you’re looking for the best stretch mark removal cream, then Mylo Care Stretch Mark Cream is one of the best stretch mark cream out there. Formulated with striover, saffron, coconut oil, shea butter and kokum, our anti stretch mark cream is Made Safe Australia-certified and helps prevent and fade stretch marks, relieve itchy skin and reduce dark spots and wrinkles.',
  },
  {
    questionName:
      'When should I start using a stretch marks cream during pregnancy?',
    acceptedAnswerText:
      "It's recommended to start using the stretch mark cream early on in pregnancy to maximize skin hydration and elasticity. You can use the Mylo Care anti stretch mark cream for pregnancy from the first month itself.",
  },
  {
    questionName: 'What is the Mylo Care stretch marks cream price in India?',
    acceptedAnswerText:
      'The Mylo Care Stretch Marks Removal Cream price is Rs 329.',
  },
  {
    questionName:
      'How to choose the best cream for stretch marks after pregnancy?',
    acceptedAnswerText:
      'If you’re looking for the best stretch marks cream after delivery, then do consider using the Mylo Care Cream for stretch marks after pregnancy. It is truly one of the best stretch mark removal cream after pregnancy.',
  },
  {
    questionName: 'Can I use this cream for stretch marks on stomach?',
    acceptedAnswerText:
      'Yes, you can use this stretch mark scar cream for reducing stretch marks on stomach, thighs, buttocks and breasts.',
  },
  {
    questionName:
      'How long does it take for this cream to reduce stretch marks?',
    acceptedAnswerText:
      'Women who have used the Mylo Care Stretch Mark Cream have noticed visible reduction in their stretch marks within 12 weeks of using this post pregnancy stretch marks cream.',
  },
];
export const stretchMarksOilFAQsData = [
  {
    questionName: 'How often should I apply a stretch mark oil?',
    acceptedAnswerText:
      'You should apply a stretch marks removal oil at least twice daily for best results.',
  },
  {
    questionName: 'Which oil is best for stretch marks?',
    acceptedAnswerText:
      'The best oil for stretch marks includes rosehip, almond, coconut and jojoba oil, which are known for their skin-nourishing properties.',
  },
  {
    questionName: 'Which is the best oil for pregnancy stretch marks?',
    acceptedAnswerText:
      'Argan oil is often considered the best oil for pregnancy stretch marks due to its hydrating and nourishing properties.',
  },
  {
    questionName: 'How soon can I start using a pregnancy stretch mark oil?',
    acceptedAnswerText:
      "You can start using an oil for stretch marks during pregnancy as soon as you find out you're pregnant to help prevent stretch marks from forming.",
  },
  {
    questionName: 'How effective is argan oil for stretch marks?',
    acceptedAnswerText:
      'Argan oil is effective for reducing stretch marks due to its high vitamin E and fatty acid content, which help improve skin elasticity.',
  },
  {
    questionName: 'How effective is coconut oil for stretch marks?',
    acceptedAnswerText:
      'Coconut oil can be effective for preventing and reducing stretch marks due to its moisturizing and antioxidant properties.',
  },
  {
    questionName: 'How to choose the best oil for stretch marks?',
    acceptedAnswerText:
      'When it comes to choosing the best oil to remove stretch marks, look for oils rich in vitamins A, C, and E, along with essential fatty acids, to nourish and hydrate the skin like the Mylo Care Stretch Mark Oil. It is enriched with sea buckthorn oil, rosehip oil, argan oil, coconut oil and murumuru butter, all of which combined help to reduce and prevent stretch marks, moisturize and soothe dry, itchy skin and enhance skin elasticity.',
  },
  {
    questionName: 'Where can I use a stretch marks removal oil?',
    acceptedAnswerText:
      'You can use an anti stretch mark oil on areas prone to stretch marks, such as the abdomen, thighs, hips, and breasts.',
  },
  {
    questionName:
      'What ingredients should the best oil for stretch marks during pregnancy have?',
    acceptedAnswerText:
      'The best oil for pregnancy stretch marks should contain natural ingredients like rosehip oil, shea butter, and vitamin E to help nourish and protect the skin.',
  },
  {
    questionName:
      'How often should I use an oil for stretch marks during pregnancy?',
    acceptedAnswerText:
      'Use a pregnancy stretch mark oil at least twice daily to keep the skin moisturized and improve its elasticity.',
  },
];

export const stretchMarksComboData = [
  {
    questionName: 'What is include in the stretch mark combo?',
    acceptedAnswerText:
      'Our stretch marks combo includes a specially formulated stretch mark oil and a hydrating stretch mark cream designed to work together to minimize the appearance of stretch marks.',
  },
  {
    questionName: 'At what time should I use the stretch mark oil?',
    acceptedAnswerText: 'You can apply the stretch marks removal oil at night.',
  },
  {
    questionName: 'When should I use the stretch mark cream?',
    acceptedAnswerText:
      'It is recommended to use the stretch mark removal cream during the day.',
  },
  {
    questionName:
      'How do anti stretch mark oil and anti stretch mark cream work?',
    acceptedAnswerText:
      'Stretch mark oils and creams work by hydrating and nourishing the skin, improving its elasticity and reducing the appearance of existing stretch marks.',
  },
  {
    questionName:
      'How often should I use the stretch marks removal oil and stretch mark removal cream?',
    acceptedAnswerText:
      'For best results, we recommend using the anti stretch mark oil and cream at least twice a day, preferably in the morning and evening. Alternatively, you can use the cream during the day and the oil at night.',
  },
  {
    questionName: 'Are the products safe for use during pregnancy?',
    acceptedAnswerText:
      "Yes, our stretch mark products are safe for use during pregnancy and while breastfeeding. However, it's always best to consult with a healthcare professional before using any new skincare products during pregnancy.",
  },
  {
    questionName: 'Can these products be used on all skin types?',
    acceptedAnswerText:
      'Yes, our stretch mark combo is suitable for all skin types, including sensitive skin.',
  },
  {
    questionName: 'How do I apply the pregnancy stretch mark cream and oil?',
    acceptedAnswerText:
      'Apply the stretch marks removal oil first, massaging it into the affected areas, then follow with the stretch mark removal cream, ensuring thorough coverage and absorption.',
  },
  {
    questionName:
      'How long does it take to see the results of the pregnancy stretch mark oil?',
    acceptedAnswerText:
      'Results may vary, but many users notice an improvement in the appearance of their stretch marks within a few weeks of consistent use.',
  },
  {
    questionName:
      'Can I use this oil and cream for stretch marks after pregnancy?',
    acceptedAnswerText:
      'Yes, you can use our pregnancy stretch mark oil and pregnancy stretch mark cream even after pregnancy to reduce pregnancy stretch marks.',
  },
];

export const babyBodyWash = [
  {
    questionName: 'Can I use the Mylo Baby Body Wash and Shampoo every day?',
    acceptedAnswerText:
      'Yes, this body wash and shampoo is safe for everyday use as it is Made Safe certified and dermatologically tested.',
  },
  {
    questionName: 'Is this Baby Shampoo for Hair irritating to the eyes?',
    acceptedAnswerText:
      'No, the Mylo Baby shampoo is made with a tear-free formulation, so it is not irritating to your baby’s eyes.',
  },
  {
    questionName: 'What makes it the best baby shampoo?',
    acceptedAnswerText:
      'Our dermatologically-tested and Made Safe Australia-certified baby shampoo is made for gentle head to toe cleansing, made with ingredients like extracted honey, reetha, vitamin E, coconut oil and hydagen aquaporin for tear-free baths.',
  },
  {
    questionName: 'Can adults use this Baby Shampoo?',
    acceptedAnswerText:
      'Yes, people of all ages can use this baby body wash and shampoo but it is specially formulated for babies.',
  },
  {
    questionName: 'How often can I use this baby wash?',
    acceptedAnswerText:
      'For newborns, using baby body wash and shampoo 2-3 times a week is generally sufficient. As your baby grows and becomes more active, you may want to use it every 2-3 days or as needed, such as after messy mealtimes or playtime.',
  },
  {
    questionName: 'Can I use this as baby face wash?',
    acceptedAnswerText:
      'Yes, you can use the Mylo baby body wash for cleansing your baby’s wash as well. It’s tear-free formulation and gentle ingredients ensure no harm or irritation to your baby’s face and skin.',
  },
  {
    questionName: 'Which is the best baby shampoo in India?',
    acceptedAnswerText:
      'If you’re looking for a baby shampoo in India, then you can consider using the Mylo baby shampoo and wash. It is dermatologically tested and Made Safe Australia-certified, providing a gentle, tear-free bath to babies.',
  },
  {
    questionName: 'What is the Mylo Baby shampoo price?',
    acceptedAnswerText:
      'You can get the Mylo baby wash and shampoo for Rs 299.',
  },
  {
    questionName: 'Can we use this baby shampoo for hair growth?',
    acceptedAnswerText:
      'Yes, our baby shampoo is great for hair growth in babies as it is made with ingredients like reetha and coconut oil, which help boost hair growth and health.',
  },
  {
    questionName: 'Is it a mild baby shampoo?',
    acceptedAnswerText:
      'Yes, it is a gentle baby shampoo made with mild ingredients and free from harmful chemicals like SLS/SLES, paraben and mineral oil.',
  },
  {
    questionName: 'What are the Mylo baby shampoo ingredients?',
    acceptedAnswerText:
      'The Mylo baby hair shampoo is made with ingredients like extracted honey, reetha, vitamin E, coconut oil and hydagen aquaporin for tear-free baths.',
  },
  {
    questionName: 'How to choose the best baby body wash?',
    acceptedAnswerText:
      'When it comes to choosing the best baby body wash in India, consider opting for a baby wash that is fragrance-free and hypoallergenic to minimize the risk of skin irritation, and ensure it is formulated specifically for delicate baby skin.',
  },
];
const babySoapFaqs = [
  {
    questionName: 'Can adults use this baby soap?',
    acceptedAnswerText: 'Yes, adults can use this soap.',
  },
  {
    questionName: 'How to choose the best baby soap in India?',
    acceptedAnswerText:
      'To choose the best baby soap, look for one that is hypoallergenic, free of toxins, and made with natural ingredients, like Mylo newborn baby soap.',
  },
  {
    questionName: 'Which is the best soap for newborn baby?',
    acceptedAnswerText:
      'The best soap for a newborn baby is one that is gentle, made with natural ingredients and free of harsh chemicals, such as the Mylo baby soap.',
  },
  {
    questionName: 'Can I use this baby soap for face?',
    acceptedAnswerText:
      "Yes, you can use Mylo baby bath soap for your baby's face as it is gentle and nourishing for delicate facial skin.",
  },
  {
    questionName: 'Can we use this baby soap for skin whitening?',
    acceptedAnswerText:
      "The colour of a baby’s skin is determined by their genes and products like soaps or creams cannot change it. Instead of looking for a baby skin whitening soap, you should look for a soap that provides gentle cleansing and nourishment for the baby's delicate skin.",
  },
  {
    questionName: 'Can I use this baby soap for dry skin?',
    acceptedAnswerText:
      'Yes, you can use the Mylo baby soap for dry skin, as it contains moisturizing ingredients like Murumuru butter, coconut oil and Vitamin E.',
  },
  {
    questionName: 'What makes it the best baby soap?',
    acceptedAnswerText:
      'Gentle and natural ingredients like murumuru butter, coconut oil, jojoba oil and Vitamin E and zero harmful chemicals make it the best baby soap in India.',
  },
  {
    questionName: 'Can I use this soap for my newborn baby?',
    acceptedAnswerText: 'Yes, it is absolutely safe to use for newborn babies.',
  },
  {
    questionName: 'What is the Mylo baby soap price?',
    acceptedAnswerText: 'A single pack of 75 g costs Rs. 65.',
  },
];

export const babyCarrierFaqs = [
  {
    questionName: 'What is the age and weight limit for this baby carrier?',
    acceptedAnswerText:
      'The Mylo Baby Carrier basket is suitable for 4-36 months old babies and can carry up to 15 kg weight.',
  },
  {
    questionName: 'Is this a newborn baby carrier?',
    acceptedAnswerText:
      'Baby carriers are generally not recommended for newborns since they don’t have head and neck control. You can use our baby shoulder carrier for babies above 4 months of age, around when they have developed head and neck control.',
  },
  {
    questionName: 'What are the features in this baby carrier wrap?',
    acceptedAnswerText:
      'Our ergonomic baby carrier offers 4 different carrying positions, padded neck and shoulder support, comes with a bottle holder and is travel friendly.',
  },
  {
    questionName: 'Which is the best baby carrier in India?',
    acceptedAnswerText:
      'If you’re looking for the best baby carrier, then do consider the Mylo Baby Carrier, made with premium micro polycotton honeycomb material. It offers padded shoulder strap and padded waist belt, four different carrying positions, a bottle holder and is travel friendly.',
  },
  {
    questionName: 'Is this baby carrier backpack suitable for extended wear?',
    acceptedAnswerText:
      'The padded shoulder strap and waist belt allows you to go hands-free for extended duration, which is what makes this a baby travel carrier.',
  },
  {
    questionName: 'What is the Mylo Baby Carrier price?',
    acceptedAnswerText: 'You can buy the Mylo Baby Carrier Wrap for Rs 1499.',
  },
  {
    questionName: 'How to choose the best baby carrier?',
    acceptedAnswerText:
      'By considering your lifestyle, understanding different carrier types, prioritizing safety and support features, and testing different options, you can choose the best baby carrier in India.',
  },
  {
    questionName: 'Can I use this baby carrier bag for 3-year-old?',
    acceptedAnswerText:
      'Yes, you can use the Mylo baby sling carrier for a 3 year old baby.',
  },
  {
    questionName: 'How should I clean this baby shoulder carrier?',
    acceptedAnswerText:
      'You can wash the baby shoulder carrier in machine using a mild laundry detergent. Unfasten the strap and zips first and avoid soaking for long duration. You can dry it in natural sunlight.',
  },
  {
    questionName: 'What fabric is this baby travel carrier made of?',
    acceptedAnswerText:
      'Our baby carrier wrap is made with premium micro polycotton honeycomb material, which is breathable and keeps the baby comfy and relaxed.',
  },
];
export const antiHairFallKit = [
  {
    questionName: 'What all is included in this hair kit set?',
    acceptedAnswerText:
      'Our hair kit includes onion hair oil, onion shampoo and an onion conditioner of 200 ml each.',
  },
  {
    questionName: 'Is this onion hair care kit suitable for all hair types?',
    acceptedAnswerText:
      'Yes, the Mylo Care hair fall control kit is suitable for all hair types as it is free from harmful chemicals like mineral oil, silicone, paraben etc.',
  },
  {
    questionName:
      'How often should I use the products in this hair growth kit?',
    acceptedAnswerText:
      'You can use the oil, shampoo and conditioner as frequently as you wash your hair, at least 1-2 times a week.',
  },
  {
    questionName:
      'Are there any side effects of using this anti hair fall kit?',
    acceptedAnswerText:
      'No, our onion hair fall kit is free from harmful chemicals like mineral oil, silicone, paraben etc. and doesn’t cause any side effects.',
  },
  {
    questionName: 'What are the ingredients of the onion hair oil?',
    acceptedAnswerText:
      'The Mylo Care onion oil is enriched with ingredients like onion seed oil, Bhringraj, Amla, Methi and ylang ylang. The oil has no added chemical fragrance and is free from sulfate, paraben, and mineral oil.',
  },
  {
    questionName: 'What are the ingredients of the onion shampoo?',
    acceptedAnswerText:
      'The Mylo Care onion hair shampoo is formulated with ingredients like onion seed oil, tetrapeptide, plant keratin, Methi and Amla. The shampoo is enriched with onion seed oil to promote hair growth and keep the scalp healthy.',
  },
  {
    questionName: 'What are the ingredients of the onion conditioner?',
    acceptedAnswerText:
      'The Mylo Care Onion Hair Conditioner is made with ingredients like red onion oil, tetrapeptide, Bhringraj and rosemary.',
  },
  {
    questionName:
      'Does this hair regrowth kit help with dandruff and itchy scalp?',
    acceptedAnswerText:
      'Yes, with regular use of our onion hair growth kit you may see visible improvement in dandruff and scalp itchiness.',
  },
  {
    questionName: 'Can we use this hair care kit for men?',
    acceptedAnswerText: 'Yes, even men can use our hair care kit.',
  },
  {
    questionName: 'How should I use this hair fall control kit?',
    acceptedAnswerText:
      'To use our anti-hair fall kit, first apply the onion oil, then wash your hair with the onion shampoo and lastly, use the onion conditioner. This 3-step regime can work wonders for your hair.',
  },
];

export const lactomamaGrancules = [
  {
    questionName: 'How quickly will I see results after using Lactomama?',
    acceptedAnswerText:
      'Many moms notice a difference in milk supply within 7 days of regular use.'  },
  {
    questionName: 'Is Lactomama safe for me and my baby?',
    acceptedAnswerText:
      'Yes, Lactomama is made with safe, natural ingredients and is designed specifically for breastfeeding moms.',
  },
  {
    questionName:
      'How do I use Lactomama?',
    acceptedAnswerText:
      'Lactomama is easy to use. Just mix 2 scoops into a glass of milk, water or smoothie daily.',
  },
  {
    questionName:
      'How long should I take Lactomama?',
    acceptedAnswerText:
      'It is recommended to continue for at least 6 months for best breastfeeding and postpartum recovery support.',
  },
    {
    questionName:
      'When can I start taking Lactomama after delivery?',
    acceptedAnswerText:
    'You can begin taking Lactomama 4 days after birth.',
  },
  {
    questionName: 'Can Mylo Lactomama be consumed while recovering from a C-section?',
    acceptedAnswerText:
      'Absolutely! Its ingredients like Moringa and Panchatrina Mool aid postpartum recovery and enhance lactation'
     },
  
  
];

export const babyWipesFaqs = [
  {
    questionName: 'What are baby wipes used for?',
    acceptedAnswerText:
      'Baby tissue wipes are primarily used for cleaning babies during diaper changes, but they can also be used for cleaning hands, face, and even surfaces.',
  },
  {
    questionName: 'Are baby wet wipes safe for newborns?',
    acceptedAnswerText:
      'Yes, there are specific newborn baby wipes that are gentle and safe for their delicate skin.',
  },
  {
    questionName: 'Can I use these wet wipes for face?',
    acceptedAnswerText:
      'Yes, you can use these baby skincare wipes on the face as well.',
  },
  {
    questionName: 'Do baby cleaning wipes expire?',
    acceptedAnswerText:
      "Yes, baby cleaning wipes do have an expiration date. It's important to check the packaging for the expiration date and use them before they expire.",
  },
  {
    questionName: 'What ingredients should I look for in baby skincare wipes?',
    acceptedAnswerText:
      'Look for a wet wipe that is free from alcohol, parabens, and fragrances, and is hypoallergenic and dermatologically tested.',
  },
  {
    questionName: 'How many newborn baby wipes do I need for a day?',
    acceptedAnswerText:
      "On average, you may need about 10 to 12 baby wipes per day for a newborn. However, this can vary based on your baby's individual needs, how messy diaper changes are, and how often you choose to use wipes for other cleaning purposes.",
  },
  {
    questionName: 'How should I store baby tissue wipes?',
    acceptedAnswerText:
      'Baby wet wipes should be stored in a cool, dry place and away from direct sunlight to prevent them from drying out.',
  },
  {
    questionName: 'Can I flush wet wipe down the toilet?',
    acceptedAnswerText:
      "It's not recommended to flush baby cleaning wipes down the toilet as they can cause plumbing issues. Dispose of used wipes in the trash.",
  },
  {
    questionName: 'How to choose the best baby wipes in India?',
    acceptedAnswerText:
      'When choosing the best baby wipes, consider the ingredients, thickness, texture, fragrance, and whether they are suitable for sensitive skin.',
  },
  {
    questionName: 'What is the Mylo Baby wipes price?',
    acceptedAnswerText:
      'You can get two packs of without lid Mylo Baby Wipes for Rs. 170, which contains 80 wipes in each pack.',
  },
];

export const waterBabyWipes = [
  {
    questionName: 'What are water wipes?',
    acceptedAnswerText:
      'Water wipes are baby wipes made with a high percentage of water and are designed to be gentle on delicate skin.',
  },
  {
    questionName: 'Are these wipes safe for newborns?',
    acceptedAnswerText:
      'Yes, our sensitive baby wipes are safe for newborns. They are hypoallergenic and suitable for use on sensitive skin, including premature babies.',
  },
  {
    questionName:
      'Can pure water wipes be used for purposes other than diaper changes?',
    acceptedAnswerText:
      'Yes, water wipes are versatile and can be used for cleaning hands, face, and even surfaces.',
  },
  {
    questionName: 'How long do gentle baby wipes stay fresh once opened?',
    acceptedAnswerText:
      'Once opened, they typically stay fresh for up to a month if the packaging is resealed properly after each use.',
  },
  {
    questionName: 'Can water wipes replace regular baby wipes?',
    acceptedAnswerText:
      'Yes, these wipes can be used as an alternative to regular baby wipes, especially for babies with sensitive skin or allergies to certain ingredients.',
  },
  {
    questionName: 'How to choose the best wipes for sensitive skin?',
    acceptedAnswerText:
      'If you’re looking for sensitive baby wipes, then consider a high percentage of water content, a natural plant-based fabric, pH balance and the absence of harmful chemicals like SLS, parabens, artificial preservatives etc.',
  },
  {
    questionName: 'How to choose the best wet wipes for baby?',
    acceptedAnswerText:
      'To choose the best wet wipes for your baby, look for wipes that are hypoallergenic, free from alcohol, parabens, fragrances, and other harsh chemicals, extra thick and adequately moistened.',
  },
  {
    questionName: 'Can pure water wipes be flushed down the toilet?',
    acceptedAnswerText:
      'It is not recommended to flush wipes down the toilet, as they can contribute to clogging. Properly dispose of used water wipes in a waste bin.',
  },
  {
    questionName: 'Are water wipes tested on animals?',
    acceptedAnswerText:
      'Our 99.5% ultra pure water wipes are cruelty-free and not tested on animals.',
  },
  {
    questionName:
      'Are there any specific storage instructions for these wipes?',
    acceptedAnswerText:
      "It's recommended to store the gentle wipes in a cool, dry place and away from direct sunlight to maintain their quality and moisture content. Ensure that the packaging is properly sealed after each use to prevent drying out.",
  },
  {
    questionName: 'Do water wipes contain any harmful chemicals?',
    acceptedAnswerText:
      'No, our wipes are free from alcohol, fragrance, parabens, and other harmful chemicals, making them safe for sensitive skin.',
  },
];

export const diaperPantDiscussionData = [
  {
    questionName: 'What are the key features of Mylo Baby Diaper Pants ?',
    acceptedAnswerText:
      'Mylo Baby Diaper Pants offers up to 12 hours of leak-proof protection. They feature ADL (Acquisition Distribution Layer) Technology for even fluid distribution, Aloe Vera lotion to soothe the skin, and a breathable, cottony-soft top layer certified by OEKO-TEX, ensuring safety and comfort.',
  },
  {
    questionName: 'Are these diaper pants safe for sensitive skin',
    acceptedAnswerText:
      "Yes, Mylo Diaper Pants are dermatologically tested and MADE SAFE certified, making them suitable for babies with sensitive skin. The Aloe Vera-infused top layer helps prevent rashes and keeps your baby's skin moisturized",
  },
  {
    questionName: 'How do I choose the correct diaper size for my baby',
    acceptedAnswerText: `For newborns weighing up to 5 kg, the Newborn (NB) size is recommended. As babies grow, the Small (S) size is suitable for those between 4 to 8 kg. The Medium (M) size fits babies weighing 7 to 12 kg, while the Large (L) size is designed for those in the 9 to 14 kg range. For slightly older or larger babies, the Extra Large (XL) size is ideal for 12 to 17 kg, the XXL size for 15 to 25 kg, and the XXXL size for 18 to 35 kg. Therefore, a baby weighing 4 to 8 kg would comfortably fit into the Small (S) size.`,
  },
  {
    questionName: 'Can Mylo Diaper Pants be used overnight?',
    acceptedAnswerText:
      'Yes, these diaper pants offer up to 12 hours of absorption, making them suitable for overnight use. The ADL Technology ensures even fluid distribution, preventing leaks and keeping your baby dry throughout the night',
  },
  {
    questionName: 'How often should I change the diaper?',
    acceptedAnswerText:
      "It's recommended to change the diaper every 8–10 hours or immediately when soiled to maintain hygiene and prevent diaper rash.",
  },
  {
    questionName: 'What is ADL Technology in Mylo Diaper Pants?',
    acceptedAnswerText:
      "ADL (Acquisition Distribution Layer) Technology in Mylo Diaper Pants ensures quick absorption and even distribution of fluids, preventing leakage and keeping your baby's skin dry and comfortable",
  },
  {
    questionName: 'Are Mylo Diaper Pants eco-friendly?',
    acceptedAnswerText:
      'While Mylo Diaper Pants are disposable, they are made with OEKO-TEX certified materials, ensuring they are free from harmful chemicals. For an eco-friendly option, Mylo also offers reusable cloth diapers.',
  },
  {
    questionName: 'Do these diapers have a wetness indicator?',
    acceptedAnswerText:
      "The Small (S) size diaper pants do not feature a wetness indicator. However, Mylo's Newborn (NB) size diapers come with a wetness indicator to help parents know when it's time for a change.",
  },
  {
    questionName: 'How do Mylo Diaper Pants compare to other brands?',
    acceptedAnswerText:
      'Mylo Diaper Pants stand out due to their combination of features: 12-hour leak protection, Aloe Vera-infused top layer, ADL Technology, and OEKO-TEX certification. These features ensure comfort, safety, and reliability, making them a preferred choice among parents',
  },
  {
    questionName: 'Where can I purchase Mylo Baby Diaper Pants?',
    acceptedAnswerText:
      "You can purchase Mylo Baby Diaper Pants directly from the official website: <a href='https://mylofamily.com/product/baby-diaper-pants-small-s-size-4-8-kgs-42-count-leak-proof-lightweight-rash-free-12-hours-protection-2378'>Mylo Baby Diaper Pants Small Size, 4-8 kg, 84 Count</a>",
  },
];

export const PDPDiscussionData = {
  283: lotionDiscussionData,
  451: shampooDiscussionData,
  1092: onionSerumDiscussionData,
  728: onionConditionerDiscussionData,
  286: onionHairOilDiscussionData,
  3408: ovolunaDiscussionData,
  3662: ovolunaDiscussionData,
  3663: ovolunaDiscussionData,
  729: faceMoisturizer,
  730: faceMistData,
  731: faceWashData,
  1090: faceSerumData,
  1219: vitaminBodyWash,
  1218: vitaminBodyLotion,
  816: vitaminCombo,
  456: ubtanFaceWashData,
  1217: ubtanBodyWashData,
  1216: ubtanBodyLotionData,
  1735: ubtanComboData,
  862: teaTreeFashWash,
  1096: teaTreeFaceMask,
  1089: teaTreeFaceCream,
  3774: breastPumpFaqs,
  280: stretchMarksFAQsData,
  847: stretchMarksOilFAQsData,
  979: stretchMarksComboData,
  381: babyBodyWash,
  3511: babySoapFaqs,
  3434: babyCarrierFaqs,
  820: antiHairFallKit,

  3455: waterBabyWipes,
  3744: waterBabyWipes,
  3730: waterBabyWipes,
  3746: waterBabyWipes,
  3745: waterBabyWipes,
  3747: waterBabyWipes,

  791: babyWipesFaqs,
  3148: babyWipesFaqs,
  792: babyWipesFaqs,
  2169: babyWipesFaqs,
  2317: babyWipesFaqs,
  2319: babyWipesFaqs,
  2321: babyWipesFaqs,
  789: babyWipesFaqs,
  3147: babyWipesFaqs,
  790: babyWipesFaqs,
  2320: babyWipesFaqs,
  2318: babyWipesFaqs,
  2316: babyWipesFaqs,

  3839: diaperPantDiscussionData,
  3840: diaperPantDiscussionData,
  3841: diaperPantDiscussionData,
  3842: diaperPantDiscussionData,
  3459: diaperPantDiscussionData,
  3725: diaperPantDiscussionData,
  3742: diaperPantDiscussionData,
  2378: diaperPantDiscussionData,
  2379: diaperPantDiscussionData,
  2380: diaperPantDiscussionData,
  2381: diaperPantDiscussionData,
  3149: diaperPantDiscussionData,
  3150: diaperPantDiscussionData,
  3151: diaperPantDiscussionData,
  3152: diaperPantDiscussionData,
  3483: diaperPantDiscussionData,
  3484: diaperPantDiscussionData,
  3485: diaperPantDiscussionData,
  3486: diaperPantDiscussionData,
  3928: lactomamaGrancules,
};

export const acceptedFaqsIds = Object.keys(PDPDiscussionData);

export const getFaqsHtmlData = (id) => {
  const faqsData = PDPDiscussionData[id];
  if (!faqsData) return '';
  let htmlData = `<h2>
      <strong>FAQs&nbsp;</strong>
    </h2>`;

  faqsData?.forEach((element, index) => {
    htmlData += `<h4>
        <span>
          <strong>${index + 1}.&nbsp</strong>
        </span>
        <strong>${element?.questionName}</strong>
        </h4>
        <p>
        <span style="color: black;">${element?.acceptedAnswerText}</span>
        </p>
     `;
  });
  return htmlData;
};

export const checkShowFaqs = (userType) => {
  // if (!userType) return true;
  // return userType === "A";
  return true;
};

export const formatIndianNumber = (number) => {
  // Convert the number to a string
  let strNumber = String(number);

  // Split the string into parts based on thousand separator
  let parts = strNumber.split('.');

  // Extract the integer part
  let integerPart = parts[0];

  // Extract the decimal part if exists
  let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

  // Add commas for Indian numbering system
  let formattedIntegerPart = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');

  // Concatenate integer and decimal parts
  return formattedIntegerPart + decimalPart;
};

export const getShowPriceSection = (userType) => {
  // if (!userType) return null;
  // return userType === "B";
  return true;
};

export const queryParamHandling = (url, custom_query) => {
  let newUrl = url;
  let customQuery = '';
  const params = new URLSearchParams(window.location.search);
  keysToRemove.forEach((elm) => {
    params.delete(elm);
  });

  params.delete('variant');
  if (custom_query) {
    customQuery = removeDefaultParams(custom_query);
    customQuery = Object.keys(customQuery)
      .map((key) => key + '=' + customQuery[key])
      .join('&');
  }
  if (url?.includes('variant')) {
    newUrl = url.split('?')?.[0];
    const variant = url.split('?')?.[1]?.split('=')?.[1];
    params.append('variant', variant);
  }
  const addParams = params.size
    ? '?' + params
    : customQuery
      ? '?' + customQuery
      : '';
  return { addParams, newUrl };
};
